import { render, staticRenderFns } from "./CommonHeaderWrap.vue?vue&type=template&id=996dd6b6&scoped=true"
import script from "./CommonHeaderWrap.vue?vue&type=script&lang=js"
export * from "./CommonHeaderWrap.vue?vue&type=script&lang=js"
import style0 from "./CommonHeaderWrap.vue?vue&type=style&index=0&id=996dd6b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996dd6b6",
  null
  
)

export default component.exports